import EventType from './EventType';

const TriggerType = {
  AGENT: 'AGENT',
  ASSET: 'ASSET',
  BLACKOUT: 'BLACKOUT',
  CONTAINERS: 'CONTAINERS',
  CUSTOM_KOMAND: 'CUSTOM_KOMAND',
  ENGINE: 'ENGINE',
  GOAL: 'GOAL',
  INFRASTRUCTURE: 'INFRASTRUCTURE',
  REMEDIATION_PROJECT: 'REMEDIATION_PROJECT',
  SCAN: 'SCAN',
  SCAN_CREDENTIALS: 'SCAN_CREDENTIALS',
  VULNERABILITY: 'VULNERABILITY',
  VULNERABILITY_COUNT: 'VULNERABILITY_COUNT',
  VULNERABILITY_EXCEPTIONS: 'VULNERABILITY_EXCEPTIONS',
};

Object.freeze(TriggerType);
export default TriggerType;

export const TRIGGER_TYPES_BY_EVENT_TYPE = {
  [EventType.ACTION]: [
    TriggerType.ASSET,
    TriggerType.REMEDIATION_PROJECT,
    TriggerType.SCAN,
    TriggerType.VULNERABILITY,
    TriggerType.VULNERABILITY_COUNT,
  ],
  [EventType.NOTIFICATION]: [TriggerType.ASSET, TriggerType.VULNERABILITY],
  [EventType.WORKFLOW]: [TriggerType.ASSET, TriggerType.VULNERABILITY],
};
Object.freeze(TRIGGER_TYPES_BY_EVENT_TYPE);
